import { ColumnDef } from "@tanstack/react-table";
import i18n from "@/lang/i18n";
import { DataTableColumnHeader } from "@/components/custom/DataTableColumnHeader"; // Adjust the import path as needed

export type HubChargerStatusFullyCharged = {
  charger_number: string;
  vehicle_number: string;
  start_soc: string;
  end_soc: string;
};

export const useFullyChargedColumns =
  (): ColumnDef<HubChargerStatusFullyCharged>[] => {
    return [
      {
        accessorKey: "charger_number",
        header: ({ column }) => (
          <DataTableColumnHeader
            column={column}
            title={`${i18n.t("chargerNumber")}`}
            className="w-24"
          />
        ),
      },
      {
        accessorKey: "vehicle_number",
        header: ({ column }) => (
          <DataTableColumnHeader
            column={column}
            title={`${i18n.t("vehicleNumber")}`}
            className="w-24"
          />
        ),
      },
      {
        accessorKey: "start_soc",
        header: ({ column }) => (
          <DataTableColumnHeader
            column={column}
            title={`${i18n.t("startSOC")}`}
            className="w-24"
          />
        ),
      },
      {
        accessorKey: "end_soc",
        header: ({ column }) => (
          <DataTableColumnHeader
            column={column}
            title={`${i18n.t("endSOC")}`}
            className="w-24"
          />
        ),
      },
    ];
  };
